// /api/emailService.js
import axiosInstance from './axiosInstance';

export default {
  sendEmail(emailData) {
    return axiosInstance.post('/email/send', emailData);
  },
};
